/// <amd-module name="Feed/Core/Redux/Navigation/NavigationActions" />
import { Action, ActionsUnion, createAction } from "redux/Utils/ActionHelper";

import { IHubState } from "./NavigationContracts";

export const enum MetaTypes {
    FEED_HUB_ACTION = "FEED_HUB_ACTION",
    REPLACE_HISTORY = "REPLACE_HISTORY"
}

export const enum NavigationActionTypes {
    // User Actions
    NavigateToHub = "Navigation/NavigateToHub",
    NavigateToPage = "Navigation/NavigateToPage",

    // UI Actions
    HubStateChange = "UI/Navigation/HubStateChange"
}

//  Creates an action which indicates that this action involves a hub switch
export function hubSwitchAction<T, A extends Action<T>>(action: A, hubAction: string): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.FEED_HUB_ACTION] = hubAction;
    return action;
}

// Indicates that the current history point should be replaced (instead of a new point added).
// Generally used when the previous point is now invalid.
export function replaceHistoryPoint<T, A extends Action<T>>(action: A): A {
    if (!action.meta) {
        action.meta = {};
    }

    action.meta[MetaTypes.REPLACE_HISTORY] = true;
    return action;
}

export const NavigationActions = {
    // User Actions
    navigateToHub: (hubAction: string) => createAction(NavigationActionTypes.NavigateToHub, hubAction),
    navigateToPage: (hubState: IHubState) => createAction(NavigationActionTypes.NavigateToPage, hubState),

    // UI Actions
    hubStateChange: (hubState: IHubState) => createAction(NavigationActionTypes.HubStateChange, hubState)
};

export type NavigationActions = ActionsUnion<typeof NavigationActions>;
